import { createContext } from 'react';

export const CalloutContext = createContext({});
